"use stritc";

export default {
  "SET_AMOUNT_OF_MODULE_ONE"(state, payload = 0) {
    state.amountOfModuleOne = payload;
  },
  "SET_AMOUNT_OF_MODULE_TWO"(state, payload = 0) {
    state.amountOfModuleTwo = payload;
  },
  "SET_AMOUNT_OF_MODULE_TWO_ONE"(state, payload = 0) {
    state.amountOfModuleTwoOne = payload;
  },
  "SET_AMOUNT_OF_MODULE_TWO_TWO_PERCENT"(state, payload = 0) {
    state.amountOfModuleTwoTwoPercent = payload;
  },
  "SET_AMOUNT_OF_MODULE_THREE"(state, payload = 0) {
    state.amountOfModuleThree = payload;
  },
  "SET_AMOUNT_OF_MODULE_FOUR"(state, payload = 0) {
    state.amountOfModuleFour = payload;
  },
  "SET_AMOUNT_OF_MODULE_FIVE"(state, payload = 0) {
    state.amountOfModuleFive = payload;
  },
  "SET_AMOUNT_OF_MODULE_SIX"(state, payload = 0) {
    state.amountOfModuleSix = payload;
  },
  "SET_AMOUNT_OF_CONSUMABLES_BY_MONTH"(state, payload = {}) {
    state.amountOfConsumablesByMonth = payload;
  },
  "SET_AMOUNT_OF_EQUIPMENTS_BY_MONTH"(state, payload = {}) {
    state.amountOfEquipmentsByMonth = payload;
  },
  "SET_AMOUNT_OF_UNIFORMSANDEPIS_BY_MONTH"(state, payload = 0) {
    state.amountOfUniformsByMonth = payload;
  },
  "SET_AMOUNT_OF_UTENSILS_BY_MONTH"(state, payload = {}) {
    state.amountOfUtensilsByMonth = payload;
  },
  "SET_ANALYTICAL_WORKSHEET"(state, payload = {}) {
    state.analyticalWorksheet = payload;
  },
  "SET_BUDGET"(state, payload = {}) {
    state.budget = payload;
  },
  "SET_BUDGET_FINALIZED"(state, payload = {}) {
    state.budgetFinalized = payload;
  },
  "SET_HAS_CHANGE"(state, payload = {}) {
    state.hasChange = payload;
  },


}



// WEBPACK FOOTER //
// ./src/store/modules/budget/mutations.js